import { render, staticRenderFns } from "./S304.vue?vue&type=template&id=2cb910ca&scoped=true"
import script from "./S304.vue?vue&type=script&lang=js"
export * from "./S304.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=2cb910ca&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb910ca",
  null
  
)

export default component.exports